import http from '../shared/HttpCommon';
import { Dispatch, SetStateAction } from 'react';

export type CommentStatus = 'DONE' | 'OPEN' | 'APPROVAL' | '';

export interface FilterOptions {
  textSearch?: string;
  commentStatus?: CommentStatus;
  company?: string;
  endDate?: string;
  kind?: string;
  pageSize: number;
  offset: number;
  orderBy?: string[];
  platform?: string;
  score: number[];
  startDate?: string;
  withComments: boolean;
  withoutComments: boolean;
  isUpdated?: boolean;
  isDeleted?: boolean;
  hasNotes?: boolean;
  hasDeletion?: boolean;
  withGmb: boolean;
  withMonitoring: boolean;

  status?: string;
  type: string;
  groupId?: string;
}

const saveReviewComment = async (
  reviewId: string,
  status: string,
  text: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.patch('/portal/comments/reviews/comment', {
      reviewId,
      comment: {
        status,
        text,
      },
    });
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const deleteReviewComment = async (
  reviewId: string,
  loading: Dispatch<SetStateAction<boolean>>
) => {
  try {
    loading(true);
    const { data } = await http.delete(`/portal/comments/reviews/comment/${reviewId}`);
    loading(false);
    return data;
  } catch (error) {
    loading(false);
    console.error(error);
  }
};

const deleteReviewHistory = async (reviewId: string, historyIndex: string) => {
  try {
    const { data } = await http.delete(`/portal/comments/review/${reviewId}/${historyIndex}`);
    return data;
  } catch (error) {
    console.error(error);
  }
};

const getAllReviews = async (controller: AbortController, filter: FilterOptions) => {
  const { data } = await http.post('/portal/comments/reviews', filter, {
    signal: controller.signal,
  });
  return data;
};

const CommentingService = {
  saveReviewComment,
  deleteReviewHistory,
  deleteReviewComment,
  getAllReviews,
};

export default CommentingService;
